<kendo-grid [data]="orderSelectionGridData"
            class="orderSelectionGridCls"
            [sortable]="true"
            [selectable]="false"
            [navigable]="true"
            [filterable]="true"
            [groupable]="false"
            [reorderable]="true"
            [resizable]="true"
            [sort]="orderGridstate.sort"
            [pageable]="{ buttonCount: 5, info: true, pageSizes:[50,75,100] }"
            [pageSize]="orderGridstate.take"
            [skip]="orderGridstate.skip"
            [columnMenu]="{ filter: false, sort: false }"
            (sort)="orderGridSortChange($event)"
            (pageChange)="orderGridPageChange($event)"
            (dataStateChange)="orderDataStateChange($event)"
            [filter]="gridSettings.state.filter"
            [loading]="loadingClaims">
  <!--(columnReorder)="onReorder($event)"
  (columnVisibilityChange)="onVisibilityChange($event)"-->
  <ng-template kendoGridToolbarTemplate>
    <div class="k-grid-toolbar-button-display btn-web">
      <!--<button kendoButton class="excel-button" icon="file-excel" [disabled]="loadingExcel" (click)="generateExcel()">
        {{orderlblText.exportToExcelLbl?orderlblText.exportToExcelLbl:orderInquiryGridLbl.exportToExcelLbl}}
        <kendo-loader *ngIf="loadingExcel"></kendo-loader>
      </button>
      <button kendoButton icon="file-pdf" class="pdf-button" [disabled]="loadingPDF" (click)="generatePDF()">
        {{orderlblText.exportToPDFLbl?orderlblText.exportToPDFLbl:orderInquiryGridLbl.exportToPDFLbl}}
        <kendo-loader *ngIf="loadingPDF"></kendo-loader>
      </button>-->
    </div>
    <!--<div class="row pwaOrderInquirySearch" style="width:100%;">
      <div class="col-sm-3 col-md-2 paddingZero" style="padding-top:2px;">
        {{orderlblText.orderDatelbl ? orderlblText.orderDatelbl : orderInquiryGridLbl.orderDatelbl}}:
      </div>
      <div class="col-sm-9 col-md-5  paddingZero">
        <app-grid-daterange-pwa-filter class="date-range-filter"
                                       [filter]="gridSettings.state.filter"
                                       field="orderDateAsDate">
        </app-grid-daterange-pwa-filter>
      </div>
      <div class="col-sm-12 col-md-5  paddingZero">
        <input placeholder="Search in all columns..."
               kendoTextBox
               (input)="onFilterOrderInquiry($event.target.value)" class="searchClass" [(ngModel)]="searchTextOrderInquiry" />

      </div>

    </div>-->
  </ng-template>
  <!--<kendo-grid-column media="(max-width: 1024px)" title="Order Inquiry">
    <ng-template kendoGridCellTemplate let-dataItem>
      <div class="row  mb-3">
        <div class="col-12 job-name">
          <a class="link" [routerLink]="['/order-inquiry/order-detail']" (click)="orderDetail(dataItem.orderNumber, dataItem.orderType)">{{dataItem.orderNumber}}</a>
          - {{dataItem.jobName}}
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 col-md-4 paddingZero">
          <span class="txt-bold">{{orderlblText.orderDatelbl ? orderlblText.orderDatelbl : orderInquiryGridLbl.orderDatelbl}}:</span> <span class="float-right-pwa"> {{dataItem.orderDateUIString}}</span>
        </div>

        <div class="col-sm-4 col-md-4 paddingZero">
          <span class="txt-bold">{{orderlblText.scheduleDatelbl ? orderlblText.scheduleDatelbl : orderInquiryGridLbl.scheduleDatelbl}}:</span> <span class="float-right-pwa"> {{dataItem.scheduleDateUIString}}</span>
        </div>
        <div class="col-sm-4 col-md-4 paddingZero">
          <span class="txt-bold">{{orderlblText.polbl ? orderlblText.polbl : orderInquiryGridLbl.polbl}}:</span> <span class="float-right-pwa"> {{dataItem.poNumber}}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 col-md-4 paddingZero">
          <span class="txt-bold">{{orderlblText.jobNumberlbl ? orderlblText.jobNumberlbl : orderInquiryGridLbl.jobNumberlbl}}:</span> <span class="float-right-pwa"> {{dataItem.jobNumber}}</span>
        </div>
        <div class="col-sm-4 col-md-4 paddingZero">
          <span class="txt-bold">{{orderlblText.orderTypeLbl ? orderlblText.orderTypeLbl : orderInquiryGridLbl.orderTypeLbl}}:</span> <span class="float-right-pwa"> {{dataItem.orderType}}</span>
        </div>

        <div class="col-sm-4 col-md-4 paddingZero">
          <span class="txt-bold">{{orderlblText.shipFromlbl ? orderlblText.shipFromlbl : orderInquiryGridLbl.shipFromlbl}}:</span> <span class="float-right-pwa"> {{dataItem.shipFrom}}</span>
        </div>
        <div class="col-sm-4 col-md-4 paddingZero">
          <span class="txt-bold">{{orderlblText.kdReflbl ? orderlblText.kdReflbl : orderInquiryGridLbl.kdReflbl}}:</span> <span class="float-right-pwa"> {{dataItem.kdReference}}</span>
        </div>
      </div>


    </ng-template>
  </kendo-grid-column>-->
  <kendo-grid-column *ngFor="let col of gridSettings.columnsConfig"
                     [field]="col.field"
                     [title]="col.title"
                     [width]="col._width"
                     [filter]="col.filter"
                     [filterable]="col.filterable"
                     [hidden]="col.hidden"
                     [format]="col.format" media="(min-width: 1025px)">
    <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem *ngIf="col.field == 'claimNumber'">
      <a class="link" [routerLink]="['/self-service/claim-history/view-claim/:claimId']" (click)="proceedToMyClaimDetails(dataItem)">{{dataItem.claimNumber}}</a>
      <kendo-filter-contains-operator></kendo-filter-contains-operator>
    </ng-template>
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column" *ngIf="col.field == 'orderDateAsDate'">
      <app-grid-daterange-filter class="date-range-filter"
                                 [filter]="filter"
                                 field="orderDateAsDate">
      </app-grid-daterange-filter>
    </ng-template>
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column" *ngIf="col.field == 'scheduleDateUIString'">
      <app-grid-daterange-filter class="date-range-filter"
                                 [filter]="filter"
                                 field="scheduleDateAsDate">
      </app-grid-daterange-filter>
    </ng-template>
  </kendo-grid-column>
  <!--<kendo-grid-column>
    <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem>
      <a class="link" [routerLink]="['/self-service/view-claim/:claimId']" (click)="proceedToClaimSubmissionScreen(dataItem)">Select</a>
      <kendo-filter-contains-operator></kendo-filter-contains-operator>
    </ng-template>
  </kendo-grid-column>-->
  <ng-template kendoGridNoRecordsTemplate>
  </ng-template>

</kendo-grid>

<!--<div class="d-super-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row" style="text-align: center">
  <button kendoButton
          (click)="proceedToClaimSubmissionScreen()"
          class="m-3 clearKendoButton btn btn-success" style="margin: 0 auto;">
    Proceed to Raise Claim
  </button>
</div>-->
